export default __webpack_public_path__ + "feature-list.png";